import { useEffect } from "react"
import { generatePath, Link, useNavigate } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Flex, List, Typography } from "antd"

import { balancesStore } from "@src/app/balanceStore"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { paths } from "@src/app/paths"
import { Transaction } from "@src/app/transactionsStore"
import { TransactionEntity } from "@src/app/transactionsStore/TransactionEntity"
import { GRefundPage } from "@src/pages/refund/classes/RefundPage"
import { TransactionRefundEntity } from "@src/pages/refund/classes/TransactionRefundEntity"
import css from "@src/pages/reports/index.module.css"
import { GlobalChargesCollection } from "@src/pages/transactionsIn/classes/ChargesCollection"
import { WithCopy } from "@src/shared/componemts/WithCopy"
import { dateTimeFormat } from "@src/shared/date"
import { getExplorerUrl } from "@src/shared/getExplorerUrl"

export const ReportsTableExpandable = observer(
  ({
    isLoading,
    transaction,
  }: {
    isLoading: boolean
    transaction: Transaction
  }) => {
    const { created_at, final, id, operation, status } = transaction
    const types = ["checkout", "charge", "invoice"]
    const charges = GlobalChargesCollection()
    const { currencies } = balancesStore
    const { Item } = List
    const operationWithUrl = getExplorerUrl([operation], currencies)[0]
    const nav = useNavigate()
    const shouldShowChargeId = types.includes(operation.resource)
    const payment = shouldShowChargeId
      ? charges.findPaymentById(operation.id)
      : undefined

    const finalCurrency = GlobalCurrenciesCollection().getBySymbolNetwork({
      network: final.network,
      symbol: final.symbol,
    })

    const feeCurrency = operation.fee
      ? GlobalCurrenciesCollection().getBySymbolNetwork({
          network: operation.fee?.network,
          symbol: operation.fee?.symbol,
        })
      : undefined

    const operationCurrency = operation
      ? GlobalCurrenciesCollection().getBySymbolNetwork({
          network: operation.network,
          symbol: operation.symbol,
        })
      : undefined

    const makeRefund = () => {
      GRefundPage().setEntity(
        new TransactionRefundEntity(new TransactionEntity(transaction)),
      )

      nav(paths.refund)
    }

    useEffect(() => {
      if (!shouldShowChargeId || payment || charges.isLoading) return

      void charges.loadPaymentById(operation.id)
    }, [charges, charges.isLoading, operation.id, payment, shouldShowChargeId])

    return (
      <div className={css.listWrapper}>
        <List
          loading={isLoading || charges.isLoading}
          style={{ width: "100%" }}
        >
          <Item className={css.listItem}>
            <div className={css.listTitle}>Date</div>
            <div>{dateTimeFormat(created_at as string)}</div>
          </Item>
          <Item className={css.listItem}>
            <div className={css.listTitle}>Type</div>
            <div>{operation.resource}</div>
          </Item>
          <Item className={css.listItem}>
            <div className={css.listTitle}>Custom ID</div>
            <div>{id}</div>
          </Item>
          {shouldShowChargeId && (
            <Item className={css.listItem}>
              <div className={css.listTitle}>Charge ID</div>
              <div>
                {payment?.charge_id ? (
                  <WithCopy content={payment.charge_id} />
                ) : (
                  "-"
                )}
              </div>
            </Item>
          )}
          <Item className={css.listItem}>
            <div className={css.listTitle}>Currency</div>
            <div>{`${operationCurrency?.symbol_alias ?? operation.symbol} (${operation.network})`}</div>
          </Item>
          <Item className={css.listItem}>
            <div className={css.listTitle}>Status</div>
            <div>{status}</div>
          </Item>
          <Item className={css.listItem}>
            <div className={css.listTitle}>Amount</div>
            <div>{`${operation.amount} ${operationCurrency?.symbol_alias ?? operation.symbol} (${operation.network})`}</div>
          </Item>
          <Item className={css.listItem}>
            <div className={css.listTitle}>Fee</div>
            <div>
              {operation.fee?.amount
                ? `${operation.fee.amount} ${feeCurrency?.symbol_alias ?? operation.fee.symbol} (${operation.fee.network})`
                : 0}
            </div>
          </Item>
          <Item className={css.listItem}>
            <div className={css.listTitle}>Amount credited</div>
            <div>{`${final?.amount} ${finalCurrency?.symbol_alias ?? final?.symbol} (${final?.network})`}</div>
          </Item>
          {operation.ext_tx_id && (
            <Item className={css.listItem}>
              <div className={css.listTitle}>TxID</div>
              <Link
                id="GENERATED_ID_REPORTSTABLEEXPANDABLE_LINK_VOID_1"
                target="_blank"
                to={operationWithUrl.tx_explorer_url + operation.ext_tx_id}
              >
                {operation.ext_tx_id}
              </Link>
            </Item>
          )}
          {operation.resource === "payout" && (
            <Item className={css.listItem}>
              <div className={css.listTitle}>Recipient</div>
              <div>{operation.address}</div>
            </Item>
          )}
        </List>
        {/*{types.includes(operation.resource) && (*/}
        {/*  <Flex justify="center" style={{ width: "100%" }}>*/}
        {/*    <Button*/}
        {/*      id="GENERATED_ID_REPORTSTABLEEXPANDABLE_BUTTON_REFUND_1"*/}
        {/*      onClick={makeRefund}*/}
        {/*      size="large"*/}
        {/*      type="primary"*/}
        {/*    >*/}
        {/*      Refund*/}
        {/*    </Button>*/}
        {/*  </Flex>*/}
        {/*)}*/}
      </div>
    )
  },
)
